import React from 'react';
import PropTypes from 'prop-types';

import Badge from '../Badge';
import { IconArrowDown, IconArrowUp } from '../icons/Icons';

export default function DropdownMenuButton(props) {
    const {
        badgeCount,
        label,
        isExpanded,
        isDisabled,
        innerRef,
        ...rest
    } = props;

    return (
        <button
            className="rec-select"
            disabled={isDisabled}
            ref={innerRef}
            {...rest}>
            <span className="rec-select-label">
                {label}

                <span className="rec-select-badge">
                    {typeof badgeCount === 'number' && (
                        <Badge appearance="info">{badgeCount}</Badge>
                    )}
                </span>
            </span>

            <span className="rec-select-icon">
                {isExpanded ? <IconArrowUp /> : <IconArrowDown />}
            </span>
        </button>
    );
}

DropdownMenuButton.propsTypes = {
    badgeCount: PropTypes.number.isRequired,
    label: PropTypes.node.isRequired,
    isExpanded: PropTypes.bool.isRequired,
    isDisabled: PropTypes.bool,
    innerRef: PropTypes.oneOfType([
        PropTypes.shape({ current: PropTypes.node }),
        PropTypes.func
    ]).isRequired
};

DropdownMenuButton.defaultProps = {
    isExpanded: false,
    isDisabled: false
};